export const removeSpaces = (val: string) => val.replace(/\s/g, '');
